import React, { forwardRef } from 'react'
import { Typography } from '@telavita-core/react-design-kit'

interface ApproachCardProps {
  name: string
  description: string
}

export const ApproachCard = forwardRef<HTMLDivElement, ApproachCardProps>(({name, description}, ref) => (
  <div className='ApproachCard' ref={ref}>
    <Typography variant='content1' weight='bold'>{name}</Typography>
    <Typography variant='content2' customClassName='ApproachCard__Description'>{description}</Typography>
  </div>
)) 
